import type { ISiteOption } from "@/customTypings/customer/Customer";

export function isActiveSite(site: ISiteOption): boolean {
    return site.isEnabled === true && site.isDeleted !== true;
}

export function isReportingEligibleSite(site: ISiteOption): boolean {
    return isActiveSite(site) && site.reportingActiveFlag === true;
}

export function sortSitesByName(sites: ReadonlyArray<ISiteOption>): ISiteOption[] {
    return [...sites].sort((a, b) => a.siteName.localeCompare(b.siteName, undefined, { sensitivity: "base" }));
}

export function filterDefaultsEligibleSites(sites: ReadonlyArray<ISiteOption>): ISiteOption[] {
    return sortSitesByName(sites.filter(isActiveSite));
}

export function filterReportingEligibleSites(sites: ReadonlyArray<ISiteOption>): ISiteOption[] {
    return sortSitesByName(sites.filter(isReportingEligibleSite));
}

/**
 * Picks the defaults page site: stored preference when still eligible, else sole site, else first alphabetical.
 */
export function pickInitialDefaultsSiteId(
    eligibleSites: ReadonlyArray<ISiteOption>,
    storedSiteId?: string | null
): string | null {
    if (eligibleSites.length === 0) return null;

    if (storedSiteId && eligibleSites.some((s) => s.id === storedSiteId)) {
        return storedSiteId;
    }

    if (eligibleSites.length === 1) {
        return eligibleSites[0].id;
    }

    return sortSitesByName(eligibleSites)[0]?.id ?? null;
}

/**
 * Resolves a preferred site id when it is reporting-eligible; otherwise the sole/first reporting-eligible site.
 */
export function resolveNewWasteMovementSiteId(
    reportingEligibleSites: ReadonlyArray<ISiteOption>,
    preferredSiteId?: string | null
): string {
    if (preferredSiteId && reportingEligibleSites.some((s) => s.id === preferredSiteId)) {
        return preferredSiteId;
    }
    if (reportingEligibleSites.length === 1) {
        return reportingEligibleSites[0].id;
    }
    return "";
}
